import {useEffect} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {useSelector} from 'react-redux';

import {useFeature} from 'components/feature';
import {GENERAL_EXPERIMENT_INDICATION} from 'constants/analytics/events/general';

import {getCompleteOrderFirstErrorCode} from '../../store/selectors/completeOrder/completeOrder';
import {getNameSelectedMethod} from '../../store/selectors/paymentStep/paymentStep';
import {
    INSUFFICIENT_FUNDS,
    CREDIT_CART_METHODS,
} from '../bnplOfferPopup/bnplOfferPupupList/constant';

/**
 * Hook that handles analytics events for the payment step
 */
export const usePaymentStepAnalytics = () => {
    const isCheckoutInsufficientFundsOffer = useFeature('checkoutInsufficientFundsOffer');
    const orderPaymentMethod = useSelector(getNameSelectedMethod);
    const completeOrderErrorCode = useSelector(getCompleteOrderFirstErrorCode);

    useEffect(() => {
        if (
            orderPaymentMethod &&
            completeOrderErrorCode === INSUFFICIENT_FUNDS &&
            CREDIT_CART_METHODS.includes(orderPaymentMethod)
        )
            sendDesktopAnalyticsPerSession({
                event: GENERAL_EXPERIMENT_INDICATION,
                isInteraction: false,
                label: {
                    expName: 'checkoutInsufficientFundsOffer',
                    label: isCheckoutInsufficientFundsOffer,
                },
            });
    }, [completeOrderErrorCode, isCheckoutInsufficientFundsOffer, orderPaymentMethod]);
};
